// extracted by mini-css-extract-plugin
export default {"form":"styles_form__ljFI1","card":"styles_card__FqdKF"};